import React from "react";
import { useForm } from "react-hook-form";
import parse from "html-react-parser";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";

interface IProps {
    planCost: any;
    totalCost: any;
    tax: any;
    familyProtectionCharge: any;
    newCharge: any;
    message: any;
    adultCount: any;
    refund?: any;
}

const ThankYouDialogAddRemoveFamilyMember: React.FunctionComponent<{ closeDialog(): void; props: IProps }> = (prop) => {
    const packageInformationData = useSelector((state: ApplicationState) =>
        state?.protectionPlanState?.protectionPlanData?.packageList ? state?.protectionPlanState?.protectionPlanData?.packageList : []
    );
    const activePackage = packageInformationData ? packageInformationData.find((x) => x.IsActive === true) : null;

    const { handleSubmit } = useForm({
        mode: "onSubmit",
    });

    const onSubmit = () => {
    };

    return (
        <>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <RenderIcons iconName="cube" />
                </div>
                <h1>{!!prop.props.refund ? "Household Member Removed" : "Thank you!"}</h1>
            </div>
            <form onSubmit={handleSubmit(onSubmit)} id="protection-plan-upgrade-form-container">
                <div className={false ? "loading dialog-body" : "dialog-body"}>
                    <div className="form-row">
                        <p>{prop.props.message ? parse(prop.props.message) : ""}</p>
                    </div>
                    <div className="line-divider margin-vertical-xs"></div>

                    {
                        <div className="form-row data-grid has-lines row-height-sm">
                            <fieldset className="form-row inline">
                                <div className="row data-row">
                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-current-charge">
                                            <strong>Plan Cost</strong>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div className="data-value" aria-labelledby="label-current-charge">
                                            ${Number(prop.props.planCost).toFixed(2)}
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset className="form-row inline">
                                <div className="row data-row">
                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-current-charge">
                                            <strong>Family Protection X {prop.props.adultCount}</strong>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div className="data-value" aria-labelledby="label-current-charge">
                                            ${Number(prop.props.familyProtectionCharge).toFixed(2)}
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            {prop.props.tax && (
                                <fieldset className="form-row inline">
                                    <div className="row data-row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label" id="label-current-charge">
                                                <strong>Sales Tax</strong>
                                            </div>
                                        </div>

                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="data-value" aria-labelledby="label-current-charge">
                                                ${Number(prop.props.tax).toFixed(2)}
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            )}
                            <fieldset className="form-row inline">
                                <div className="row data-row">
                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-current-charge">
                                            <strong>Total Cost</strong>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div className="data-value" aria-labelledby="label-current-charge">
                                            ${Number(prop.props.totalCost).toFixed(2)}/{activePackage?.SubcriptionType === "Yearly" ? "yr" : "mo"}
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    }
                    <div className="form-row data-grid row-height-sm">
                        <fieldset className="form-row inline">
                            <div className="row data-row">
                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-todays-charge">
                                        <h4 className="status-good">{!!prop.props.refund ? "Today's Refund" : "Today's Net Charge"}</h4>
                                    </div>
                                </div>

                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="label-todays-charge">
                                        <div className="row between-xs">
                                            <div className="col-xs col-no-gutter flex-grow-null">
                                                <h4 className="status-good">
                                                    {"$" + Number(!!prop.props.refund ? prop.props.refund : prop.props.newCharge).toFixed(2)}
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </div>

                <div className="dialog-footer">
                    <div className="row between-xs">
                        <div className="col-xs col-no-gutter flex-grow-null"></div>
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button
                                type="submit"
                                className="btn-default btn-primary"
                                id="btn-submit-purchase"
                                disabled={false}
                                onClick={() => {
                                    prop.closeDialog();
                                }}
                            >
                                <span className="btn-text">Close</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
};
export default ThankYouDialogAddRemoveFamilyMember;
